import { render, staticRenderFns } from "./org-list.vue?vue&type=template&id=47d28c3a&scoped=true"
import script from "./org-list.vue?vue&type=script&lang=js"
export * from "./org-list.vue?vue&type=script&lang=js"
import style0 from "./org-list.vue?vue&type=style&index=0&id=47d28c3a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d28c3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d28c3a')) {
      api.createRecord('47d28c3a', component.options)
    } else {
      api.reload('47d28c3a', component.options)
    }
    module.hot.accept("./org-list.vue?vue&type=template&id=47d28c3a&scoped=true", function () {
      api.rerender('47d28c3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal_order/terminal_fee/form/org-list.vue"
export default component.exports